
// Service
import breedingManagementService from "@/app/services/main/breeding-management/breeding-management-service.js";


// Components
const ModalAddWhelpBirthType = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "modal-add-whelp-birth-type" */ "@/app/views/main-view/breeding-management/mating/modals/modal-add-whelp-birth-type/modal-add-whelp-birth-type.vue"
    );

// Mixins
import { tableMixins } from "@/app/mixins/utils/table-mixins"
import { dateMixins } from "@/app/mixins/utils/date-mixins"
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins"
import { comingSoonMixins } from "@/app/mixins/utils/coming-soon-mixins"

// Utils
import { capitalizeFirstLetter } from "@/utils/text-utils.js"

// Constants
import { STATUS_CODES, MATING_STATUS } from "@/app/constants/status-constants"
import { BREEDER_ROUTES } from '@/app/constants/breeder-routes-constants';

export default {
    name: 'MatingListCardComponent',
    components: { ModalAddWhelpBirthType },
    directive: {},
    filters: {},
    mixins: [
        tableMixins,
        dateMixins,
        toastMessageMixins,
        comingSoonMixins
    ],
    props: {},
    data() {
        return {
            isAPILoading: false,
            didFetchData: false,
            matingName: '',
            damName: '',
            sireName: '',
            breed: '',
            status: '',

            limit: 10,
			// pagination
			page: 1,
			pageCount: 0,
			totalCount: 0,
			// sorting
			sortBy: '',
			desc: true,
			columnsFilter: {},

            matingList: [],
            matingListTotalCount: 0,
            isShowMore: false,
            maximumLitters: 15,

            matingStatusOptions: [MATING_STATUS.ACTIVE, MATING_STATUS.SUCCESSFUL, MATING_STATUS.UNSUCCESSFUL],
            MATING_STATUS
        }
    },
    computed: {
        displayShowMoreButton() {
			return this.matingListTotalCount != this.matingList.length;
		}
    },
    watch: {},
    created() {
        this.getTableContent()
    },

    methods: {
        getTableContent(
			page = this.page,
			limit = this.limit,
			sortBy = this.sortBy,
			desc = this.desc,
			fromFilter = false
		) {
			page = fromFilter ? 1 : this.page
            limit = 6; // max limit per call
			this.callMatingListAPI({ page, limit, sortBy, desc })
		},
		callMatingListAPI(queryParams) {
			this.isAPILoading = true
			if (this.columnsFilter) {
				if (this.columnsFilter.f_sireName) {
					queryParams["f_sireName"] = this.columnsFilter.f_sireName
				}
				if (this.columnsFilter.f_damName) {
					queryParams["f_damName"] = this.columnsFilter.f_damName
				}
                if (this.columnsFilter.f_breedName) {
					queryParams["f_breedName"] = this.columnsFilter.f_breedName
				}
				if (this.columnsFilter.f_matingName) {
					queryParams["f_matingName"] = this.columnsFilter.f_matingName
				}

                if (this.columnsFilter.f_status) {
                    queryParams["f_status"] = this.columnsFilter.f_status
                }
				
			}

			breedingManagementService.getMatingList(queryParams)
				.then((res) => {
					if (res.status === STATUS_CODES.SUCCESS) {

                        if (this.isShowMore) {
                            this.matingList = [...this.matingList, ...res.data.data]
                            this.isShowMore = false
                        }
                        else {
                            this.matingList = res.data.data
                        }

                        this.matingList = this.matingList.map((item) => {
                            let litterLabelButton = "Add / View Litter"

                            if (item.totalLitters === 0) {
                                litterLabelButton = "Add Litter"
                            } else if (item.totalLitters >= this.maximumLitters) {
                                litterLabelButton = "View Litter"
                            } 

                            return {
                                ...item,
                                litterLabelButton
                            }
                        })

                        this.matingListTotalCount = res.data.pagination.totalCount
                        this.didFetchData = true
					} else {
						this.showAPIErrorToast(this.toastMessages.transactions().ERROR_BREEDER_DAM_SIRE, res)
					}

					this.isAPILoading = false
				})
				.catch(() => {
					this.showGenericErrorToast()
					this.isAPILoading = false
				})
		},
        puppyImage(image) {
            return image ? image : require("@/assets/images/_shared/dog-purchase.png");
        },

        showMore() {
			this.isShowMore = true
			this.onPageSelected("next")
		},
        setSelectedFilter(filterBy, event) {
			this.page = 1;
			this.isShowMore = false;

			this.onDropdownFilter(filterBy, event);
		},

        formatText(text) {
            return capitalizeFirstLetter(text)
        },
        redirectToEditMating(matingId) {
            this.$router.push(`${BREEDER_ROUTES.EDIT_MATING}?mating=${matingId}&from=mating-list`);
        },
        redirectToAddMating(){
			this.$router.push(`${BREEDER_ROUTES.ADD_MATING}`);
		},
        redirectToLitter(buttonLabel, matingId, typeOfBirth, mating) {        
            let route = BREEDER_ROUTES.LITTER_LIST
            const hasValue = typeOfBirth ? true : false;
            route = buttonLabel === "Add Litter" ? BREEDER_ROUTES.ADD_LITTER : BREEDER_ROUTES.LITTER_LIST;
           
            if (!hasValue && buttonLabel === "Add Litter") {
                this.$refs.modalAddWhelpBirthType.show({matingId: mating.id, damId: mating.damId, whelpingDate: mating.whelpingDate});
            } else {
                this.$router.push(`${route}?id=${matingId}&from=mating-list`);
            }
        },
        deleteMatingDetails() {
            this.showHomeComingSoonAlert();
        },
        statusBadge(matingStatus) {
			const statusMap = {
                [MATING_STATUS.ACTIVE]: "status--active",
				[MATING_STATUS.SUCCESSFUL]: "status--green",
				[MATING_STATUS.UNSUCCESSFUL]: "status--red",
				
			}

			return statusMap[matingStatus] || "status--red"
		},

        redirectToReminderNotes(matingId) {
            this.$router.push(`${BREEDER_ROUTES.LITTER_REMINDER_AND_NOTES}?matingId=${matingId}&from=mating-list`);
        },
    },
}